// extracted by mini-css-extract-plugin
export default {"table":"PsmPage_table__ZN-XD","materialTable":"PsmPage_materialTable__zjp64"};